import './index.scss'
import './components/RateContent/index.scss'

import React from 'react'

import Container from '@ui-pc/Container'
import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
import Switch from '@ui-pc/Switch'
import Text from '@ui-pc/Text'
import { isHomeProject } from '@utils/index'

import { Content } from './components/RateContent/components/Comment'
import ViewPhotosDetail from './components/RateContent/components/ViewPhotosDetail'
//import { Container, Flex, Switch, Text } from '../';
import RateContent from './components/RateContent/IndexV2'
import RatePanel from './components/RatePanel'
import RateSnapShot from './components/RateSnapshot'
import WriteReview from './components/WriteReview'
import useWidget from './hooks/useWidget'
import { ctx } from './utils'
import verified from './verified .png'

import type { OusideProps } from './types'
const Head = () => {
  const [state, setState] = ctx.useState()

  return (
    <>
      <Switch either={Number(state.reviewNum) > 0}>
        <>
          <Flex inlineFlex span={18} alignItems="center" warp={false}>
            <RatePanel />
          </Flex>
          <Flex
            className="write-review-box"
            inlineFlex
            span={6}
            alignItems="center"
            justify="left">
            <WriteReview />
          </Flex>
        </>
        <Flex
          paddingTop={32}
          direction="column"
          rowGap={16}
          justify="center"
          alignItems="center">
          <Text size={16} width={600} textAlign="center">
            No reviews for this rating
          </Text>
          <WriteReview />
        </Flex>
      </Switch>
    </>
  )
}

export const ViewMore = (props) => {
  const { onClick } = props
  return (
    <button
      aria-label="See All Reviews"
      className={`ind-see-all-reviews ${isHomeProject && 'home'}`}
      onClick={onClick}>
      <p>View More</p>
      <span className="img"></span>
    </button>
  )
}

function Index(props: OusideProps) {
  const { isLoading, id } = useWidget(props)

  const [state, setState] = ctx.useState()

  ctx.useHandle('main', { ViewPhotosDetail })

  React.useEffect(() => {
    if (Number(state.reviewNum) == 0) {
      setState({ isExpand: true })
    }
  }, [state.reviewNum])

  return (
    <Flex
      id="reviews"
      className="ind-widget inde-widget-yopt"
      justify="center"
      alignItems="center">
      <Flex
        paddingBottom={24}
        justify="space-between"
        warp={false}
        className="inde-widget-yopt-head-wrap"
        alignItems="center">
        <Flex
          colGap={16}
          className="content"
          warp={false}
          alignItems="center"
          direction="column"
          justify="center">
          {/* <Text size={28} className="ind-widget-reviews-title">
            Reviews {'    '}
            <Switch either={+state.reviewNum > 0}>
              <Text type="secondary"> ({state.reviewNum})</Text>
            </Switch>
            {'  '}
          </Text>
          <Flex span="auto">
            <RateSnapShot size={24} readonly num={state.score} />
          </Flex> */}
          <Text size={36} lineHeight={42} className="ind-widget-reviews-title">
            Customer Reviews
          </Text>
          <Switch either={!state.isExpand}>
            <Flex span="auto" colGap={4} warp={false} alignItems="baseline">
              <RateSnapShot span="auto" size={24} readonly num={state.score} />
              <Switch either={+state.reviewNum > 0}>
                <Text size={18}> {state.reviewNum} Reviews</Text>
              </Switch>
            </Flex>
          </Switch>
        </Flex>
        <Flex
          className="icon-buyer"
          span="auto"
          cursor
          colGap={4}
          warp={false}
          alignItems="center"
          onClick={() => setState({ isExpand: !state.isExpand })}>
          <Icon src={verified} size={20} />
          <Text size={14}>All reviews are from verified buyers</Text>
          <Icon
            customSrc={!state.isExpand ? 'icon-lower' : 'icon-upper'}
            size={14}
          />
        </Flex>
      </Flex>
      <Switch either={state.isExpand}>
        <>
          <Head />
          <Container isLoading={isLoading}>
            <RateContent key={id} />
          </Container>
        </>
        <>
          <Flex>
            <Content.Card />
          </Flex>
          <ViewMore onClick={() => setState({ isExpand: !state.isExpand })} />
          {/* <button
            aria-label="See All Reviews"
            className="see-all-reviews"
            onClick={() => setState({ isExpand: !state.isExpand })}>
            <p>View More</p>
            <span className="img"></span>
          </button> */}
        </>
      </Switch>
    </Flex>
  )
}

export default ctx.Provider((props) => <Index key={props.id} {...props} />)
